import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";
import translationEN from "./en/translation.json";
import translationES from "./es/translation.json";
import translationPT from "./pt/translation.json";
import { AuthI18N } from "@whatslly/ui-components/Pages/Authi18n";

i18n.addResources(
  "en",
  defaultNS,
  flattenResources({
    ...AuthI18N.en,
    ...translationEN,
  })
);
i18n.addResources(
  "es",
  defaultNS,
  flattenResources({
    ...translationES,
    ...AuthI18N.es,
  })
);
i18n.addResources(
  "pt",
  defaultNS,
  flattenResources({
    ...translationPT,
    ...AuthI18N.pt,
  })
);
